<template>
    <div class="loading" @click="showing()" v-if="$store.state.loaded">
        <div class="pcontent">
            <img :src="loadimg" class="rotate">
        </div>
    </div>
</template>

<script>
export default {
    // props: {
    //   loaded: {// 
    //     type: Boolean,
    //     default: false
    //   },
    // },
    data() {
        return {
            loadimg: 'data:image/png;base64,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'
        }
    },
    methods: {
        showing() {
            this.$store.commit('showing');
        }
    }
}
</script>

<style lang="scss" scoped>
    .loading{          
        width:100%;
        height:100%;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:rgba(0, 0, 0, 0.6);
        z-index: 999999999990;
        .pcontent{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                &.rotate {
                    -webkit-animation: rotating 3s linear infinite;
                    animation: rotating 3s linear infinite;
                    animation-play-state:running;
                    -webkit-animation-play-state:running; /* Safari 和 Chrome */
                }
                &.rotate-pause {
                    animation-play-state:paused;
                    -webkit-animation-play-state:paused; /* Safari 和 Chrome */
                }
                @-webkit-keyframes rotating {
                    from { -webkit-transform: rotate(0) }
                    to { -webkit-transform: rotate(360deg) }
                }

                @keyframes rotating {
                    from { transform: rotate(0) }
                    to { transform: rotate(360deg) }
                }
                @-moz-keyframes rotating {
                    from { -moz-transform: rotate(0) }
                    to { -moz-transform: rotate(360deg) }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/widgets/Loading.vue